<main>
    <h1 class="dialog-title dialog-title--bigger" >{{"DeleteExceptionConfiguration" | translate}}</h1>
    

    <mat-dialog-content>
        
        <p>
            {{"DeleteExceptionFirstPart" | translate}}
        </p> 
    </mat-dialog-content>

    <div class="loading-container" *ngIf="LoadingSavingLocks">
        <section>
            <div  class="pulsing">
              <mat-spinner [diameter]="50" ></mat-spinner>
            </div>
            <p class="pulsing">{{"Saving" | translate}}</p>
          </section>
      </div>
    

    <mat-dialog-actions align="center" >
        <button class="dialog__button" (click)="onCancel()">
            {{"Cancel" | translate}}
        </button>
        <button class="dialog__button dialog__button--fill" (click)="onSave()" [disabled]="LoadingSavingLocks">
            {{"Accept" | translate}}
        </button>
    </mat-dialog-actions>
</main>
